import { DynamicContentType } from '../../types/content.types.js'
import { LucideIconName } from '../../types/lucide.types.js'

export type CalendarData = {
  marginBottom: string
  height: number
}

export const calendar: DynamicContentType<CalendarData> = {
  name: 'calendar',
  viewName: 'Kalender',
  icon: LucideIconName.Calendar,
  uuid: '',
  featureKey: 'calendar',
  data: {
    marginBottom: '1rem',
    height: 650,
  },
}
